export const UPDATE_ACCESS_TOKEN_REQUEST_FETCH = 'UPDATE_ACCESS_TOKEN_REQUEST_FETCH'
export const UPDATE_ACCESS_TOKEN_REQUEST_SUCCESS = 'UPDATE_ACCESS_TOKEN_REQUEST_SUCCESS'
export const UPDATE_ACCESS_TOKEN_REQUEST_FAIL = 'UPDATE_ACCESS_TOKEN_REQUEST_FAIL'
